import { LocalDateTime } from 'js-joda';

import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';
import queryString from '@tock/query-string';

const { WaitlistContactAboutAvailabilityRequest } = protos;

export type WaitlistSearchQuery = {
  serviceDateTime: string;
  partySizes: number[];
  ticketTypeIds: number[];
};

export function contactPatrons(purchaseSize: number, dateTime: string, waitlistId: number[]) {
  const localDateTime = LocalDateTime.parse(dateTime);
  const request = WaitlistContactAboutAvailabilityRequest.fromObject({
    date: localDateTime.toLocalDate().toString(),
    startTime: localDateTime.toLocalTime().toString(),
    waitlistId,
    size: purchaseSize,
  });
  return {
    TockApi: {
      postProto: `/waitlist/contactpatrons`,
      type: AppConstants.NULL,
      toast: 'Contacted',
      request,
    },
  };
}

export function searchWaitlistEntries(query: WaitlistSearchQuery): ApiAction {
  const queryParams = queryString.stringify({
    ...query,
    partySizes: query.partySizes.join(','),
    ticketTypeIds: query.ticketTypeIds.join(','),
  });

  return {
    TockApi: {
      getListProto: `/waitlist/search/expanded?${queryParams}`,
      type: AppConstants.WAITLIST_FETCH_FOR_TICKET_GROUP,
    },
  };
}

export function getWaitlistEntriesForTicketGroupAndDay(
  ticketGroupIds: number[],
  ticketSubsetId?: number
): ApiAction {
  return {
    TockApi: {
      getListProto: `/waitlist/search/expanded?ticketGroupId=${ticketGroupIds.join()}${
        ticketSubsetId ? `&ticketSubsetId=${ticketSubsetId}` : ''
      }`,
      type: AppConstants.WAITLIST_FETCH_FOR_TICKET_GROUP,
    },
  };
}
